export const tokensShadow = {
    shadow: {
        none: 'none',
        top: '0 0 0 0 transparent',
        base: '0 0 0 0 transparent',
        hover: '0 0 0 0 transparent',
        focus: '0 0 0 0 transparent'
    }
};

//# sourceMappingURL=tokensShadow.js.map